import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { FaInstagram, FaFacebookF, FaWhatsapp } from 'react-icons/fa';
import { RiYoutubeLine } from 'react-icons/ri';
import { AppContext } from './AppContext';
import './Footer.css';

const Footer = () => {
  const { t } = useContext(AppContext);

  return (

    <footer className="footer">
      <div className="footer-bg" />
      <div className="footer-inner">
        <div className="footer-top">
          {/* Brand Column */}
          <div className="footer-brand">
            <div className="footer-logo-wrap">
              <img src="/images/logo.png" alt="GDR Jewellers Logo" className="footer-logo-img" />
            </div>
            <p className="brand-desc">
              {t.footerBrandDesc}
            </p>
            {/* Social Media Icons */}
            <div className="footer-social-row">
              <a 
                href="https://instagram.com/gdrjewellers" 
                target="_blank" 
                rel="noreferrer" 
                title="Instagram" 
                aria-label="GDR Jewellers on Instagram"
                className="social-btn instagram"
              >
                <FaInstagram size={20} />
              </a>
              <a 
                href="https://facebook.com/gdrjewellers" 
                target="_blank" 
                rel="noreferrer" 
                title="Facebook" 
                aria-label="GDR Jewellers on Facebook"
                className="social-btn facebook"
              >
                <FaFacebookF size={17} />
              </a>
              <a 
                href="https://wa.me/919172455555" 
                target="_blank" 
                rel="noreferrer" 
                title="WhatsApp" 
                aria-label="Chat with GDR Jewellers on WhatsApp"
                className="social-btn whatsapp"
              >
                <FaWhatsapp size={20} />
              </a>
              <a 
                href="https://youtube.com/@gdrjewellers" 
                target="_blank" 
                rel="noreferrer" 
                title="YouTube" 
                aria-label="GDR Jewellers on YouTube"
                className="social-btn youtube"
              >
                <RiYoutubeLine size={21} />
              </a>
            </div>
          </div>

          {/* Quick Links Column */}
          <div className="footer-col">
            <h4>{t.footerPageHeading}</h4>
            <ul>
              <li><Link to="/">{t.footerHomeLink}</Link></li>
              <li><Link to="/about">{t.footerAboutLink}</Link></li>
              <li><Link to="/products">{t.footerProductsLink}</Link></li>
              <li><Link to="/gifting">{t.footerGiftingLink}</Link></li>
              <li><Link to="/blog">{t.footerBlogLink}</Link></li>
              <li><Link to="/contact">{t.footerContactLink}</Link></li>
            </ul>
          </div>

          {/* Gifting Column */}
          <div className="footer-col">
            <h4>{t.footerGiftingHeading}</h4>
            <ul>
              <li><Link to="/gifting/for-her">{t.footerGiftHer}</Link></li>
              <li><Link to="/gifting/for-him">{t.footerGiftHim}</Link></li>
              <li><Link to="/gifting/for-baby">{t.footerGiftBaby}</Link></li>
              <li><Link to="/gifting/birthday">{t.footerGiftBirthday}</Link></li>
              <li><Link to="/gifting/anniversary">{t.footerGiftAnniversary}</Link></li>
              <li><Link to="/gifting/valentines-day">{t.footerGiftValentines}</Link></li>
              <li><Link to="/gifting/wedding">{t.footerGiftWedding}</Link></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="footer-col">
            <h4>{t.footerInfoHeading}</h4>
            <ul className="footer-contact-list">
              <li>
                <MapPin size={15} />
                <span>{t.footerAddress}</span>
              </li>
              <li>
                <Phone size={15} />
                <a href={`tel:${t.footerPhone1?.replace(/\s/g, '')}`}>{t.footerPhone1}</a>
              </li>
              <li>
                <Mail size={15} />
                <a href={`mailto:${t.footerEmail}`}>{t.footerEmail}</a>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2026 {t.footerCopyright}
            <span className="footer-separator"> · </span>
            Designed & Developed by{" "}
            <a
              href="https://sahyadritech.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="sahyadri-link"
            >
              Sahyadri Tech
            </a>
          </p>
          <div className="footer-bottom-right">
            <Link to="/terms">{t.footerTerms}</Link>
            <Link to="/faq">{t.footerFaq}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
